import { useContext } from 'react';
import { DevDebugContext, type DevDebugContextType } from './DevDebugContext';

export const useDevDebug = (): DevDebugContextType => {
  const context = useContext(DevDebugContext);
  if (!context && import.meta.env.DEV) {
    throw new Error('useDevDebug must be used within DevDebugProvider');
  }
  // Return no-op functions in production
  return context ?? {
    logs: [],
    errors: [],
    isDebugPanelOpen: false,
    openDebugPanel: () => {},
    closeDebugPanel: () => {},
    toggleDebugPanel: () => {},
    addLog: () => {},
    addError: () => {},
    clearLogs: () => {},
    clearErrors: () => {},
  };
};
